import { flexRender } from "@tanstack/react-table";
import { useVirtualizer } from "@tanstack/react-virtual";
import { useRef, useState } from "react";

import Text from "./Text";

const ROW_HEIGHT = 38;

const PurchaseTable = ({table, theme}) => {

    const isDark = theme.White !== "#FFFFFF";
    const rowColor = isDark ? theme.Ey : theme.Ed;
    const hoverColor = isDark ? theme.FOURFOUR : theme.Ey;
    const [hoveredRow, setHoveredRow] = useState(null);

    const leftAlignedKeys = ['code', 'provider', 'description', 'unit'];

    const getAlignment = (accessorKey) => {
        return leftAlignedKeys.includes(accessorKey) ? 'flex-start' : 'flex-end';
    };

    const getColWidth = (accessorKey) => {
        switch(accessorKey) {
            case 'description':
            case 'provider':
                return {flex: '3 1 294px', minWidth: '180px'};
            case 'code' :
                return {flex: '1.5 1 132px', minWidth: '120px'};
            case 'unit': 
                return {flex: '.5 1 60px', minWidth: '60px'};
            case 'suggestion': 
                return {flex: '1 1 120px', minWidth: '120px'};
            default:
                return {flex: '1 1 100px', minWidth: '120px'};
        }
    };

    const styles = {
        row: {
            display: 'flex', width: '100%', height: `${ROW_HEIGHT}px`, alignItems: 'center',
            boxSizing: 'border-box', backgroundColor: rowColor, border: `0.5px solid ${theme.Ey}`, borderRadius: '4px'
        },
        colWrapper: (accessorKey) => ({
            ...getColWidth(accessorKey), display: 'flex', alignItems: 'center', boxSizing: 'border-box',
            padding: '0 16px', justifyContent: getAlignment(accessorKey)
        }),
        truncate: {
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%'
        }
    }

    const containerRef = useRef(null);
    const {rows} = table.getRowModel();
    const rowVirtualizer = useVirtualizer({
        count: rows.length,
        getScrollElement: () => containerRef.current,
        estimateSize: () => ROW_HEIGHT,
        overscan: 10
    })

    return (
        <div ref={containerRef} style={{width: '100%', minWidth: 0, height: '420px', overflowY: 'auto', overflowX: 'auto'}}>
            <div style={{height: `${rowVirtualizer.getTotalSize() + ROW_HEIGHT}px`, width: '100%', minWidth: 'min-content', position: 'relative'}}>
                <div style={{position: 'sticky', top: 0, zIndex: 1, backgroundColor: rowColor}}>
                    {table.getHeaderGroups().map(headerGroup => (
                        <div key={headerGroup.id} style={styles.row}>
                            {headerGroup.headers.map(header => {
                                const accessorKey = header.column.columnDef.accessorKey;
                                const isSorted = header.column.getIsSorted();
                                const sortIcon = isSorted === 'asc' ? ' ▲' : isSorted === 'desc' ? ' ▼' : '';
                                return (
                                    <div key={header.id} onClick={header.column.getToggleSortingHandler()} style={{...styles.colWrapper(accessorKey), height: '36px', cursor: 'pointer', userSelect: 'none'}}>
                                        {header.isPlaceHolder ? null : (
                                            <>
                                                <Text size={15} weigth={500} color={theme.ONED}>{flexRender(header.column.columnDef.header, header.getContext())}</Text>
                                                <Text size={12} style={{marginLeft: '4px'}}>{sortIcon}</Text>
                                            </>
                                        )}
                                    </div>
                                )
                            })}
                        </div>
                    ))}
                </div>
                {rowVirtualizer.getVirtualItems().map(virtualRow => {
                    const row = rows[virtualRow.index];

                    let statusColor = theme.SEVENB;
                     if (row.original.futureBalance < 0) {
                        statusColor = theme.Red;
                    } else if (row.original.futureBalance < row.original.minimum && row.original.futureBalance > 0) {
                        statusColor = theme.Orange
                    } 
                    return (
                        <div key={virtualRow.key} onMouseEnter={() => setHoveredRow(row.id)} onMouseLeave={() => setHoveredRow(null)} style={{...styles.row, position: 'absolute', top: ROW_HEIGHT, left: 0, height: `${virtualRow.size}px`, transform: `translateY(${virtualRow.start}px)`, backgroundColor: hoveredRow === row.id ? hoverColor : rowColor}}>
                            {row.getVisibleCells().map(cell => {
                                const accessorKey = cell.column.columnDef.accessorKey;
                                const color = accessorKey === 'description' && row.original.isAggregated ? theme.Blue : accessorKey === 'code' && row.original.isPantoneComponente ? theme.Verde : statusColor;
                                return (
                                    <div key={cell.id} style={styles.colWrapper(accessorKey)} title={accessorKey === 'description' || accessorKey === 'provider' ? cell.getValue() : null}>
                                        <Text color={color} size={15} style={{...styles.truncate, textAlign: getAlignment(accessorKey) === 'flex-start' ? 'left' : 'right'}}>
                                            {accessorKey === 'provider' && !cell.getValue() ? '-' : accessorKey === 'code' && row.original.isAggregated ? 'Unificado' : flexRender(cell.column.columnDef.cell, cell.getContext())}
                                        </Text>
                                    </div>
                                )
                            })}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default PurchaseTable;